import { createContext, useContext } from 'react';

export const GlobalModalsContext = createContext<{
  isAuthOrConversionModalOpen: boolean;
  openBrowseTemplatesModal: () => void;
  openConversionModal: (triggerAction: string) => void;
  openOpenDiagramModal: () => void;
  openSignUpModal: () => void;
  openSignInModal: () => void;
  openSmartImportModal: () => void;
}>({
  isAuthOrConversionModalOpen: false,
  openBrowseTemplatesModal: () => {},
  openConversionModal: () => {},
  openOpenDiagramModal: () => {},
  openSignUpModal: () => {},
  openSignInModal: () => {},
  openSmartImportModal: () => {},
});

export const useGlobalModalsContext = () => useContext(GlobalModalsContext);
